import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ReportService } from 'src/app/shared/services/report.service';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;
@Component({
  selector: 'app-doctorlicense',
  templateUrl: './doctorlicense.component.html',
  styleUrls: ['./doctorlicense.component.css']
})
export class DoctorlicenseComponent implements OnInit {
  dtOptions: any = {};
  dtRender:boolean= true;
  doctorList:any[]=[]
  favIconUrl: string;
  list: any;
  webURL: string;
  locationLst:any[]=[]
  constructor(
      private toastr: ToastrService
        , private datePipe: DatePipe
        , private regService: RegistrationService
        , private reportService: ReportService
        , private modalService: NgbModal
        , private masterService: MasterService
        , private authSvc: AuthenticationService
        ,public activeModal: NgbActiveModal,
        public changeDetection: ChangeDetectorRef,
        private excelDownloadService:ExcelDownloadService,private activatedRoute: ActivatedRoute
        ,private excelService:ExcelService
  ) { }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
        buttons: [
          
            {
              extend: 'excelHtml5',
              title: 'Doctors License_list',
              exportOptions: { columns: ':visible:not(:first-child)' }
          },
          
          // {
          //     // extend: 'pdfHtml5',
          //     title: 'Data export'
          // }
      ]
  
    };
    this.getDoctorList();
    this.getDCLocations();
    this.webURL = location.href.includes('localhost') ? environment.applicationURL : location.origin;

    const orgnization_images = JSON.parse(sessionStorage.getItem('orgnization_images'))
            const favIconImage = orgnization_images.filter(f => f.image_type.id == 15)[0];
            this.favIconUrl = favIconImage?.image_path ? `${this.webURL}/vidmed-orgfiles/ORGANIATION/${sessionStorage.TENANT_ID}/${favIconImage?.image_type?.image_type}/${favIconImage?.image_path}` : `${location.origin}${environment.assetsURL}/dhanush${environment.appicon}`;
  }

  convertToLocalTime(dateString: any): string {
    if (!dateString) return ''; // Handle null/undefined cases
  
    const dateObj = dateString;
    let date:any=dateObj.substring(0,10)
    date = dateObj.substring(8, 10) + "-" + dateObj.substring(5, 7) + "-" + dateObj.substring(0, 4);
    // let time:any=dateObj.substring(11,19)
    return dateString =`${date}`; // Adjust for India, change as needed
  }

    getDoctorList(){
       this.dtRender=false
      this.regService.get(`registration/jwt/doctor/doctorlicenselist`).subscribe({
        next: res => {
          if (res.status == 'OK') {
             this.doctorList = res.data
             this.doctorList.forEach((e:any) => {e.license_start_date = this.convertToLocalTime(e.license_start_date),
             e.license_end_date = this.convertToLocalTime(e.license_end_date)
              
             });
             this.dtRender=true
            
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
            this.dtRender=true
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
  
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  
    }
    getOrderId(item:any){
  
      this.regService.get(`registration/userpayment/createorder?userId=${sessionStorage.loginId}`).subscribe({
        next: res => {
          if (res.status == 'OK') {
             this.list = res.data
             if(res.data?.orderId){
              this.payWithRazorpay(res.data?.orderId,item)
             }else{
              this.toastr.error("Order id can not be null")
             }
            
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
  
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  
    }

  payWithRazorpay(orderId:any,item:any) {
    const options: any = {
      key: 'rzp_test_mjL2zQhqtePLeI',
      amount: '30000', // 30000 paise = ₹300
      currency: 'INR',
      name: 'Dhanush',
      description: 'Test Transaction',
      image: this.favIconUrl,
      order_id: orderId,
      handler: (response: any) => {
        // ✅ This will be triggered after successful payment
        console.log('Payment Success');
        console.log('Payment ID:', response.razorpay_payment_id);
        console.log('Order ID:', response.razorpay_order_id);
        console.log('Signature:', response.razorpay_signature);
        console.log('response',response);
        // Call backend API to verify payment, if needed
        this.verifyPayment(item,response,orderId)
      },
      prefill: {
        name: 'Gaurav Kumar',
        email: 'gaurav.kumar@example.com',
        contact: '9000090000'
      },
      notes: {
        address: 'Razorpay Corporate Office'
      },
      theme: {
        color: '#3399cc'
      }
    };
    
    const rzp1 = new Razorpay(options);
    rzp1.open();
    
  
  }

  async afterPayment(item:any,response:any,orderId:any){
    let response1;
    response = await fetch(
      `https://api.razorpay.com/v1/payments/pay_QRbtgkv6OdIMa1`,
      {
        method: 'GET',
        headers: {
          Username: 'rzp_test_mjL2zQhqtePLeI',
          Password : '2OhNTYM3GoXz1QksJg9lKw6x'
  
        },
      },
    )
    const res = await response1.json();
    if (
      res.status == 'OK' && res.data != null) {
     this.verifyPayment(item,response,orderId)
      console.log('res', res.data);
    }
  }
 
  verifyPayment(item:any,response:any,orderId:any){
    let api:any;
    let payload:any
    if(item?.license_start_date){
      api = `registration/userpayment/renewal`
        if(item?.renewal_otp){
          payload =
          {
            "user_id": item?.user_id,
            "user_name": item?.doctor_name,
             "amount":300,
            "orderId": orderId,
            "response_details": response,
            "renewal_otp" : item?.renewal_otp
        }
      } else{
        payload =
        {
          "user_id": item?.user_id,
          "user_name": item?.doctor_name,
           "amount":300,
          "orderId": orderId,
          "response_details": response,
          "otp" : item?.otp
      }
      }
    }else{

       api = `registration/userpayment/licensegeneration`
       payload =
    {
      "user_id": item?.user_id,
      "user_name": item?.doctor_name,
       "amount":300,
      "orderId": orderId,
      "response_details": response
    }
    }
 
    this.regService.post(api,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }

   getDCLocations(){
  
      this.regService.get(`masters/masterdoctorbranch/getbyuserid/${sessionStorage.loginId}`).subscribe({
        next: res => {
          if (res.status == 'OK') {
             this.locationLst = res.data??[]
          //  this.toastr.success(res.message)
  
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
  
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  
    }

  onLocationChange(item: any) {
    if(item?.location_id == null || item?.location_id == '' || item?.location_id == undefined){
       this.toastr.warning("Please select location");
       return
    }
    let payload={
        "location_id": item?.location_id,
        "user_id": item?.user_id
    }
 this.regService.post(`registration/doctors/locationmapping`,payload).subscribe({
        next: res => {
          if (res.status == 'OK') {
            //  this.locationLst = res.data??[]
           this.toastr.success(res.message)
  
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
  
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
}


}
